<template>
    <div class="rounded-md bg-yellow-50 p-4">
        <div class="flex">
            <div class="flex-shrink-0">
                <i class="fa fa-exclamation-triangle text-yellow-500"></i>
            </div>
            <div class="ml-3 flex-1">
                <h3 class="text-sm font-medium text-yellow-800">
                    {{ headline }}
                </h3>
                <div class="mt-2 text-sm text-yellow-700">
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {

    name: "AlertDialog",

    props: ['headline'],

}
</script>
